import React, { useEffect } from "react";

/**
 * Composant modal de confirmation réutilisable
 * @param {boolean} show - Indique si le modal est visible
 * @param {string} title - Titre du modal
 * @param {string} message - Message de confirmation
 * @param {string} confirmText - Texte du bouton de confirmation
 * @param {string} cancelText - Texte du bouton d'annulation
 * @param {string} confirmButtonClass - Classe CSS pour le bouton de confirmation
 * @param {function} onConfirm - Fonction exécutée lors de la confirmation
 * @param {function} onCancel - Fonction exécutée lors de l'annulation
 * @param {string} icon - Classe d'icône Bootstrap Icons (sans le "bi-" préfixe)
 */
const ConfirmationModal = ({
  show,
  title = "Confirmation",
  message = "Êtes-vous sûr de vouloir effectuer cette action ?",
  confirmText = "Confirmer",
  cancelText = "Annuler",
  confirmButtonClass = "btn-danger",
  onConfirm,
  onCancel,
  icon = "question-circle",
}) => {
  // Empêcher le défilement du corps lorsque le modal est affiché
  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
      const modalBackdrop = document.createElement("div");
      modalBackdrop.className = "modal-backdrop fade show";
      document.body.appendChild(modalBackdrop);
    } else {
      document.body.classList.remove("modal-open");
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        document.body.removeChild(backdrop);
      }
    }

    return () => {
      document.body.classList.remove("modal-open");
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        document.body.removeChild(backdrop);
      }
    };
  }, [show]);

  if (!show) return null;

  // Utilisation des couleurs personnalisées du thème
  const getIconColor = () => {
    if (confirmButtonClass.includes("danger")) return "#dc3545";
    if (confirmButtonClass.includes("primary")) return "#543ba4"; // Violet
    if (confirmButtonClass.includes("highlight") || icon === "cart")
      return "#f89638"; // Orange
    return "#6c757d"; // Gris par défaut
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onCancel}
              aria-label="Fermer"
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-center">
              <div className="me-3 fs-1" style={{ color: getIconColor() }}>
                <i className={`bi bi-${icon}`}></i>
              </div>
              <p className="mb-0">{message}</p>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
            >
              {cancelText}
            </button>
            <button
              type="button"
              className={`btn ${confirmButtonClass}`}
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
